export default {
      id: "city-icon-6-usage",
      viewBox: "0 0 64 80",
      url: __webpack_public_path__ + "sprite.svg#city-icon-6",
      toString: function () {
        return this.url;
      }
    }